import { useMutation, useQueryClient } from "@tanstack/react-query";
import { notification } from "antd";
import { journalsQueries } from "@/entities/journal";
import { NOTIFICATION_MESSAGES } from "@/shared/utils";
import { updateSectionFourRecordSigned } from "../utils/update-section-four-record-signed";

interface IRequest {
  mainJournalId: string;
  section4Id: string;
  section4ListId: string;
  itemNoVersionId: string;
  companyId?: string;
  itemPartOne: {
    isDefects?: boolean;
    constructionControlInfo: string;
    controlEventPeriod?: {
      beginDate?: string;
      endDate?: string;
    };
    defectsAbsenceRecord?: string;
    defectFixingPlanDate?: string;
    defectDescriptionText?: string;
    updateDocs?: Array<any>;
    updateWorks?: Array<any>;
    createOtherDocs?: Array<any>;
    deleteOtherDocs?: Array<{ file: { id: string; fileId: string } }>;
    structuralElementName?: string;
    locationDescription?: string;
    locationType?: string;
    inspectionEmployeeId: string;
    actionDetails: string;
  };
}

export function useUpdateSectionFourEntrySigned({
  section4ListId,
  versionId,
  itemPartOneId,
  itemNoVersionId,
}: {
  section4ListId: string;
  versionId: string;
  itemPartOneId: string;
  itemNoVersionId: string;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: IRequest) =>
      updateSectionFourRecordSigned({
        sectionFourListId: section4ListId,
        versionId,
        itemPartOneId,
        updateRequest: data,
      }),
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: journalsQueries.getSection4({ section4ListId }).queryKey,
      });
      if (itemNoVersionId) {
        queryClient.setQueryData(
          journalsQueries.getSectionFourItem({ itemNoVersionId }).queryKey,
          data,
        );
      }
      notification.success({
        message: NOTIFICATION_MESSAGES.SUCCESS, // "Успешно"
        description: NOTIFICATION_MESSAGES.ENTRY_SIGNED_UPDATED_DESC, // "Подписанная запись обновлена"
      });
    },
    onError: () => {
      notification.error({
        message: NOTIFICATION_MESSAGES.ERROR, // "Ошибка"
        description: NOTIFICATION_MESSAGES.ENTRY_SIGNED_UPDATE_FAILED_DESC, // "Не удалось обновить подписанную запись"
      });
    },
  });
}


